// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f1656f18","61":"a573de65","120":"8e4420b1","147":"17604dac","181":"7896f280","333":"985974fa","799":"95502a69","830":"374554dd","945":"4fa2d838"}[chunkId] + ".chunk.js";
};